import { AlertTriangle, RefreshCw } from "lucide-react";

export function ErrorState({ message, onRetry }: { message: string; onRetry: () => void }) {
  return <div className="error-state" role="alert">
    <span><AlertTriangle size={24} /></span>
    <div><strong>Не удалось прочитать sales-данные</strong><p>{message}</p></div>
    <button type="button" onClick={onRetry}><RefreshCw size={15} />Повторить</button>
  </div>;
}
